import { Assessment } from './assessment';
import { AssessmentResult } from './assessment-result';
import { Candidate } from './candidate';
import { ExamStatus } from './exam-status';

export interface Exam {
  uuid: string;
  timeSpent: number;
  expirationDate?: Date;
  status: ExamStatus;
  candidate: Candidate;
  completionDate: Date;
  assessmentResults: AssessmentResult[];
  assessment: Assessment;
  totalAnsweredQuestions: number;
}

export function compareExams(exam1: Exam, exam2: Exam): number {
  return exam2.assessment.name.localeCompare(exam1.assessment.name);
}
